import React from 'react';
import { translate } from 'react-i18next';

import Form from '../../components/form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { getErrorValue } from '../../utils/utility';
import { requiredValidator } from '../field_group/validators';

export class SubmissionCommentDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = null;
  }

  getCommentData() {
    return this.formRef.getFormData();
  }

  clearInputData() {
    this.formRef.clearInputData();
  }

  componentDidMount() {
    if (this.props.submission) {
      this.props.listAttachment(this.props.submission);
    }
  }

  render() {
    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        {...otherAttr}
        showThumbnail={false}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="air-conditioning-central-unit-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="submission-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          errorMessage={getErrorValue(fieldErrors, 'description')}
          {...customAttr}
        />
      </Form>
    );
  }
}

export default translate('translations', { withRef: true })(
  SubmissionCommentDetail
);



// WEBPACK FOOTER //
// ./src/components/project_submission/SubmissionCommentDetail.js